export const objectHasKeys = obj => {
	if (!obj) {
		return false;
	}
	return Object.keys(obj).length > 0;
};

export const createErrorAlert = ({ error, message }) => {
	let text = `${
		error?.status ? `${error.status}: ` : ' '
	}An error occurred and has been reported to our team.`;
	if (message) {
		text = message;
	}

	return {
		message: text,
		type: 'error',
		autoDismiss: true
	};
};

export const findUrlInStringAndReturnATagTemplate = string_ => {
	const urlRegex = /(https?:\/\/[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}(?:\/[^\s]*)?)/g;
	return string_.replaceAll(urlRegex, function (url) {
		// Additional validation
		if (!url.startsWith('http://') && !url.startsWith('https://')) {
			return url; // Return as plain text if somehow invalid
		}
		return `<a target='_blank' rel='noopener noreferrer' style="word-break: break-word" href="${url}">${url}</a>`;
	});
};
